import type { PuzzleProgressPort, PuzzleProgressSummary } from '../ports/puzzle-progress';
import { lazyClientDb, PROGRESS_STORE } from './indexed-db';

export class IndexedDBPuzzleProgress implements PuzzleProgressPort {
  private readonly getDb = lazyClientDb();

  async listProgress(): Promise<PuzzleProgressSummary[]> {
    const db = await this.getDb();
    return (await db.getAll(PROGRESS_STORE)) as PuzzleProgressSummary[];
  }

  async saveProgress(summary: PuzzleProgressSummary): Promise<void> {
    const db = await this.getDb();
    await db.put(PROGRESS_STORE, summary);
  }

  async deleteProgress(puzzleId: string): Promise<void> {
    const db = await this.getDb();
    await db.delete(PROGRESS_STORE, puzzleId);
  }

  async clearProgress(): Promise<void> {
    const db = await this.getDb();
    await db.clear(PROGRESS_STORE);
  }
}
